import { useEffect, useState } from 'react'
import Tooltip from '@/components/Tooltip'
import styles from './index.module.scss'

/**
 * @param {{ file: File, onClick: () => void, sizeVariant: 'single' | 'few' | 'many' }} props
 */
export default function SentImageThumb({ file, onClick, sizeVariant }) {
  const [url, setUrl] = useState('')

  useEffect(() => {
    const u = URL.createObjectURL(file)
    // eslint-disable-next-line react-hooks/set-state-in-effect -- object URL must be created after mount; revoke in cleanup
    setUrl(u)
    return () => URL.revokeObjectURL(u)
  }, [file])

  const imgClassName =
    sizeVariant === 'single'
      ? `${styles.sentImageThumbImg} ${styles.sentImageThumbImgSingle}`
      : sizeVariant === 'few'
        ? `${styles.sentImageThumbImg} ${styles.sentImageThumbImgFew}`
        : `${styles.sentImageThumbImg} ${styles.sentImageThumbImgMany}`

  return (
    <Tooltip text={file.name} placement="top" maxLines={2} bubbleMaxWidth="160px">
      <button
        type="button"
        className={styles.sentImageThumbBtn}
        onClick={onClick}
        aria-label={`Open preview of ${file.name}`}
      >
        {url ? <img src={url} alt="" className={imgClassName} /> : null}
      </button>
    </Tooltip>
  )
}
